
import respUtility from '@/mixins/respUtility';
import { createNamespacedHelpers } from 'vuex';
import { htmlspecialcharsDecode } from '~/mixins/helpers';
import BaseIcon from '../../../common/BaseIcon.vue';

const { mapState } = createNamespacedHelpers('listing');

export default {
  components: { BaseIcon },
  name: 'ListingProductsListItem',
  mixins: [respUtility],
  props: {
    product: {
      type: Object,
      required: true,
    },
    initialLoading: {
      type: Boolean,
      default: true,
    },
    productIndex: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 36,
    },
  },
  mounted() {
    this.$emit('child-mounted');
  },
  data: () => ({
    dynamicProduct: '',
    freeHomeDeliverySrc: '',
  }),
  computed: {
    ...mapState(['searchParams']),
    syteDataPlacement() {
      return this.$store.state.pageData.type === 'search' ? 'SERP' : 'PLP';
    },
    baseRank() {
      return ((this.searchParams.page ?? 1) - 1) * this.perPage;
    },
    coupon() {
      return (this.product.labels || []).find((i) => i.toLowerCase().includes('coupon'));
    },
    unbxdProductClickPayload() {
      const productRank = (this.productIndex + 1) + this.baseRank;
      const payloadData = {
        prank: productRank,
        query: this.searchParams.text,
      };

      let productInfo = {
        pid: this.product.webId,
      };

      if (this.product.webId !== this.dynamicProduct.webId) {
        productInfo = {
          variantId: this.dynamicProduct.webId,
        };
      }
      return { ...payloadData, ...productInfo };
    },
    header() {
      return htmlspecialcharsDecode(this.dynamicProduct?.name);
    },
    imgClasses() {
      return this.product.images?.mainImage?.classes && this.product.images.mainImage.classes.length
        ? this.product.images.mainImage.classes.join(' ') : '';
    },
    tableData() {
      const tableData = { ...this.product.mattressData };
      delete tableData.label;
      // eslint-disable-next-line no-underscore-dangle
      delete tableData.__typename;
      return tableData;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    showDinamics() {
      const p = this.product;
      const rule = p?.items?.length > 1
        || p?.__typename === 'catalogSearchProductBundleItem'
        || (p?.__typename !== 'catalogSearchProductBundleItem' && p?.dynamicAttribute);
      return rule;
    },
    deliveryType() {
      return this.product.freewg
        ? 'white_glove_delivery'
        : 'home_delivery';
    },
  },
  methods: {
    changeProductInfo(webId) {
      this.dynamicProduct = this.product.items.find((item) => item.webId === webId) || this.product;

      if (this.$isSpider || (this.$device.isMobileOrTablet || this.isTouchDevice)) {
        return;
      }

      this.$emit('update-request-for-dynamics', this.dynamicProduct.slug);
    },
    unbxdAnalyticsPush() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ProductClick',
        ProductClickPayload: this.unbxdProductClickPayload,
      });
    },
  },
  created() {
    this.dynamicProduct = this.product;
  },
};
